import { View, Text, StyleSheet, Pressable, Image } from "react-native";
import { Colors } from "@/constants/Colors";
import { useTranslation } from "react-i18next";
import { ms } from "@/ui/moderateScale";
import { DESKTOP_MAX_WIDTH } from "@/constants";
import { gotoTerms, gotoPrivacy, contactUs, downloadApp } from "@/models/utils";
import { useUISlice } from "@/models/useUISlice";

const LandingPageFooter = () => {
  const { t } = useTranslation();
  const isMobile = useUISlice((state) => state.device.isMobile);

  return (
    <View style={s.container}>
      <View style={s.content}>
        <View
          style={[
            s.mainContent,
            {
              flexDirection: isMobile ? "column" : "row",
              alignItems: "center",
              justifyContent: "space-between",
            },
          ]}
        >
          <View style={s.downloadButtons}>
            {/* <Pressable
              onPress={() => downloadApp("Android")}
              accessibilityLabel={t("webPageFooter.downloadAndroid")}
            >
              <Image
                source={{ uri: "/icons/download_android.svg" }}
                style={s.downloadButton}
              />
            </Pressable>
            <View style={{ width: ms(16) }} />
            <Pressable
              onPress={() => downloadApp("iOS")}
              accessibilityLabel={t("webPageFooter.downloadIOS")}
            >
              <Image
                source={{ uri: "/icons/download_ios.svg" }}
                style={s.downloadButton}
              />
            </Pressable> */}
          </View>

          <View
            style={StyleSheet.flatten([
              s.linksSection,
              isMobile && { marginTop: ms(20), marginBottom: ms(8) },
            ])}
          >
            <Pressable onPress={gotoTerms}>
              <Text style={s.link}>{t("webPageFooter.terms")}</Text>
            </Pressable>
            <View style={s.linkDivider} />
            <Pressable onPress={gotoPrivacy}>
              <Text style={s.link}>{t("webPageFooter.privacy")}</Text>
            </Pressable>
            <View style={s.linkDivider} />
            <Pressable onPress={() => contactUs()}>
              <Text style={s.link}>{t("webPageFooter.contact")}</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </View>
  );
};

const s = StyleSheet.create({
  container: {
    borderTopWidth: 1,
    borderTopColor: Colors.gray4,
  },
  content: {
    maxWidth: DESKTOP_MAX_WIDTH,
    marginHorizontal: "auto",
    width: "100%",
    paddingVertical: ms(16),
  },
  mainContent: {},
  downloadButtons: {
    flexDirection: "row",
    alignItems: "center",
  },
  downloadButton: {
    resizeMode: "contain",
    width: ms(160),
    height: ms(50),
  },
  linksSection: {
    flexDirection: "row",
    alignItems: "center",
    gap: ms(12),
  },
  link: {
    color: Colors.subtitle,
    fontSize: ms(12),
    fontWeight: "500",
  },
  linkDivider: {
    width: ms(4),
    height: ms(4),
    borderRadius: ms(2),
    backgroundColor: Colors.gray3,
  },
  copyright: {
    textAlign: "center",
    color: Colors.subtitle,
    fontSize: ms(14),
  },
});

export default LandingPageFooter;
